"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _service = require("@insided/destination/modules/Content/TopicList/service");

var _dropdown = _interopRequireDefault(require("@insided/shared/uikit/dropdown"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _ChevronUp = _interopRequireDefault(require("@insided/shared/icons/ChevronUp"));

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var BugStatusDropdown = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(BugStatusDropdown, _Component);

  var _super = _createSuper(BugStatusDropdown);

  function BugStatusDropdown() {
    var _this;

    (0, _classCallCheck2.default)(this, BugStatusDropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isOpen: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleStatusChange", function (status) {
      var onChange = _this.props.onChange;

      _this.setState({
        isOpen: false,
        selectedStatus: status
      }, function () {
        return onChange === null || onChange === void 0 ? void 0 : onChange(status);
      });
    });
    return _this;
  }

  (0, _createClass2.default)(BugStatusDropdown, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var bugStatusList;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _service.getBugStatuses)();

              case 2:
                bugStatusList = _context.sent;

                if (bugStatusList.length) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                this.setState({
                  bugStatusList: bugStatusList
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _bugStatusList$find,
          _ref,
          _selectedStatus$name,
          _this2 = this;

      var _this$state = this.state,
          isOpen = _this$state.isOpen,
          bugStatusList = _this$state.bugStatusList,
          internalSelectedStatus = _this$state.selectedStatus;
      var _this$props = this.props,
          placeholderProp = _this$props.placeholder,
          value = _this$props.value;
      var placeholder = placeholderProp !== null && placeholderProp !== void 0 ? placeholderProp : 'Select status'; // Use value prop if provided (controlled), otherwise use internal state (uncontrolled)

      var selectedStatus = value ? (_bugStatusList$find = bugStatusList === null || bugStatusList === void 0 ? void 0 : bugStatusList.find(function (s) {
        return s.name === value;
      })) !== null && _bugStatusList$find !== void 0 ? _bugStatusList$find : internalSelectedStatus : internalSelectedStatus;
      var displayTitle = (_ref = (_selectedStatus$name = selectedStatus === null || selectedStatus === void 0 ? void 0 : selectedStatus.name) !== null && _selectedStatus$name !== void 0 ? _selectedStatus$name : value) !== null && _ref !== void 0 ? _ref : placeholder;
      return (0, _preact.h)("div", {
        className: "bug-status-dropdown"
      }, (0, _preact.h)(_dropdown.default, {
        closeOnDropdownClick: true,
        popupName: "bug-status-dropdown",
        className: "dropdown-selector",
        trigger: (0, _preact.h)(_Button.default, {
          title: displayTitle,
          endIcon: isOpen ? (0, _preact.h)(_ChevronUp.default, {
            width: 16,
            height: 16
          }) : (0, _preact.h)(_ChevronDown.default, {
            width: 16,
            height: 16
          }),
          size: "medium",
          fullWidth: true,
          onClick: function onClick() {
            return _this2.setState({
              isOpen: !isOpen
            });
          },
          "data-qa": "select-bug-status"
        }),
        triggerClass: "dropdown-selector-wrapper--control"
      }, (0, _preact.h)("ul", {
        className: "bug-status-dropdown__list"
      }, bugStatusList === null || bugStatusList === void 0 ? void 0 : bugStatusList.map(function (status) {
        return (0, _preact.h)("li", {
          className: "bug-status-dropdown__item",
          key: status.id
        }, (0, _preact.h)(_Button.default, {
          variant: "text",
          title: status.name,
          fullWidth: true,
          size: "medium",
          onClick: function onClick() {
            return _this2.handleStatusChange(status);
          }
        }));
      }))));
    }
  }]);
  return BugStatusDropdown;
}(_preact.Component);

var _default = BugStatusDropdown;
exports.default = _default;